"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.User = void 0;

var User =
/** @class */
function () {
  function User() {}

  User.prototype.EventRoleType = function () {
    return [{
      slug: 'organizer',
      name: 'Organizer',
      description: 'An Organizer has read and write access to all event related features.',
      isOrganizer: true,
      isAssistant: false,
      isSupport: false,
      isCheckInStaff: false,
      isReadOnly: false
    }, {
      slug: 'assistant',
      name: 'Assistant',
      description: 'An Assistant can view event settings, manage the guest list, handle check-ins and view reports.',
      isOrganizer: false,
      isAssistant: true,
      isSupport: false,
      isCheckInStaff: false,
      isReadOnly: false
    }, {
      slug: 'support',
      name: 'Support',
      description: 'Support can view event details, manage guest lists, and handle check-ins.',
      isOrganizer: false,
      isAssistant: false,
      isSupport: true,
      isCheckInStaff: false,
      isReadOnly: false
    }, {
      slug: 'check-in-staff',
      name: 'Check In Staff',
      description: 'Check In Staff can view event details, the guest list, and can check guests in.',
      isOrganizer: false,
      isAssistant: false,
      isSupport: false,
      isCheckInStaff: true,
      isReadOnly: false
    }, {
      slug: 'read-only',
      name: 'Read Only',
      description: 'Read Only can only view event details.',
      isOrganizer: false,
      isAssistant: false,
      isSupport: false,
      isCheckInStaff: false,
      isReadOnly: true
    }];
  };

  User.prototype.ProviderType = function () {
    return [{
      slug: 'google',
      name: 'Google',
      description: null,
      isGoogle: true,
      isMarketo: false,
      isLinkedIn: false,
      isSalesforce: false,
      isZoom: false
    }, {
      slug: 'marketo',
      name: 'Marketo',
      description: null,
      isGoogle: false,
      isMarketo: true,
      isLinkedIn: false,
      isSalesforce: false,
      isZoom: false
    }, {
      slug: 'linked_in',
      name: 'Linked In',
      description: null,
      isGoogle: false,
      isMarketo: false,
      isLinkedIn: true,
      isSalesforce: false,
      isZoom: false
    }, {
      slug: 'salesforce',
      name: 'Salesforce',
      description: null,
      isGoogle: false,
      isMarketo: false,
      isLinkedIn: false,
      isSalesforce: true,
      isZoom: false
    }, {
      slug: 'zoom',
      name: 'Zoom',
      description: null,
      isGoogle: false,
      isMarketo: false,
      isLinkedIn: false,
      isSalesforce: false,
      isZoom: true
    }];
  };

  User.prototype.RoleType = function () {
    return [{
      slug: 'none',
      name: 'None',
      description: null,
      isNone: true,
      isUser: false,
      isAdmin: false,
      isEventCrud: false,
      isEventView: false,
      isTicketBlockCrud: false,
      isTicketBlockView: false,
      isAddressBookCrud: false,
      isAddressBookView: false,
      isUserCrud: false,
      isUserView: false,
      isListView: false,
      isListCrud: false,
      isUpload: false,
      isEmail: false,
      isReports: false,
      isMassRemove: false,
      isCustomLayout: false,
      isPayments: false,
      isWillCall: false,
      isPartner: false,
      isInventoryRecords: false,
      isContestScores: false,
      isPoolContact: false,
      isExhibitorTeamMember: false
    }, {
      slug: 'user',
      name: 'User',
      description: null,
      isNone: false,
      isUser: true,
      isAdmin: false,
      isEventCrud: false,
      isEventView: false,
      isTicketBlockCrud: false,
      isTicketBlockView: false,
      isAddressBookCrud: false,
      isAddressBookView: false,
      isUserCrud: false,
      isUserView: false,
      isListView: false,
      isListCrud: false,
      isUpload: false,
      isEmail: false,
      isReports: false,
      isMassRemove: false,
      isCustomLayout: false,
      isPayments: false,
      isWillCall: false,
      isPartner: false,
      isInventoryRecords: false,
      isContestScores: false,
      isPoolContact: false,
      isExhibitorTeamMember: false
    }, {
      slug: 'admin',
      name: 'Admin',
      description: null,
      isNone: false,
      isUser: false,
      isAdmin: true,
      isEventCrud: false,
      isEventView: false,
      isTicketBlockCrud: false,
      isTicketBlockView: false,
      isAddressBookCrud: false,
      isAddressBookView: false,
      isUserCrud: false,
      isUserView: false,
      isListView: false,
      isListCrud: false,
      isUpload: false,
      isEmail: false,
      isReports: false,
      isMassRemove: false,
      isCustomLayout: false,
      isPayments: false,
      isWillCall: false,
      isPartner: false,
      isInventoryRecords: false,
      isContestScores: false,
      isPoolContact: false,
      isExhibitorTeamMember: false
    }, {
      slug: 'event-crud',
      name: 'Event CRUD',
      description: null,
      isNone: false,
      isUser: false,
      isAdmin: false,
      isEventCrud: true,
      isEventView: false,
      isTicketBlockCrud: false,
      isTicketBlockView: false,
      isAddressBookCrud: false,
      isAddressBookView: false,
      isUserCrud: false,
      isUserView: false,
      isListView: false,
      isListCrud: false,
      isUpload: false,
      isEmail: false,
      isReports: false,
      isMassRemove: false,
      isCustomLayout: false,
      isPayments: false,
      isWillCall: false,
      isPartner: false,
      isInventoryRecords: false,
      isContestScores: false,
      isPoolContact: false,
      isExhibitorTeamMember: false
    }, {
      slug: 'event-view',
      name: 'Event View',
      description: null,
      isNone: false,
      isUser: false,
      isAdmin: false,
      isEventCrud: false,
      isEventView: true,
      isTicketBlockCrud: false,
      isTicketBlockView: false,
      isAddressBookCrud: false,
      isAddressBookView: false,
      isUserCrud: false,
      isUserView: false,
      isListView: false,
      isListCrud: false,
      isUpload: false,
      isEmail: false,
      isReports: false,
      isMassRemove: false,
      isCustomLayout: false,
      isPayments: false,
      isWillCall: false,
      isPartner: false,
      isInventoryRecords: false,
      isContestScores: false,
      isPoolContact: false,
      isExhibitorTeamMember: false
    }, {
      slug: 'ticket-block-crud',
      name: 'TicketBlock CRUD',
      description: null,
      isNone: false,
      isUser: false,
      isAdmin: false,
      isEventCrud: false,
      isEventView: false,
      isTicketBlockCrud: true,
      isTicketBlockView: false,
      isAddressBookCrud: false,
      isAddressBookView: false,
      isUserCrud: false,
      isUserView: false,
      isListView: false,
      isListCrud: false,
      isUpload: false,
      isEmail: false,
      isReports: false,
      isMassRemove: false,
      isCustomLayout: false,
      isPayments: false,
      isWillCall: false,
      isPartner: false,
      isInventoryRecords: false,
      isContestScores: false,
      isPoolContact: false,
      isExhibitorTeamMember: false
    }, {
      slug: 'ticket-block-view',
      name: 'TicketBlock View',
      description: null,
      isNone: false,
      isUser: false,
      isAdmin: false,
      isEventCrud: false,
      isEventView: false,
      isTicketBlockCrud: false,
      isTicketBlockView: true,
      isAddressBookCrud: false,
      isAddressBookView: false,
      isUserCrud: false,
      isUserView: false,
      isListView: false,
      isListCrud: false,
      isUpload: false,
      isEmail: false,
      isReports: false,
      isMassRemove: false,
      isCustomLayout: false,
      isPayments: false,
      isWillCall: false,
      isPartner: false,
      isInventoryRecords: false,
      isContestScores: false,
      isPoolContact: false,
      isExhibitorTeamMember: false
    }, {
      slug: 'address-book-crud',
      name: 'Address Book CRUD',
      description: null,
      isNone: false,
      isUser: false,
      isAdmin: false,
      isEventCrud: false,
      isEventView: false,
      isTicketBlockCrud: false,
      isTicketBlockView: false,
      isAddressBookCrud: true,
      isAddressBookView: false,
      isUserCrud: false,
      isUserView: false,
      isListView: false,
      isListCrud: false,
      isUpload: false,
      isEmail: false,
      isReports: false,
      isMassRemove: false,
      isCustomLayout: false,
      isPayments: false,
      isWillCall: false,
      isPartner: false,
      isInventoryRecords: false,
      isContestScores: false,
      isPoolContact: false,
      isExhibitorTeamMember: false
    }, {
      slug: 'address-book-view',
      name: 'Address Book View',
      description: null,
      isNone: false,
      isUser: false,
      isAdmin: false,
      isEventCrud: false,
      isEventView: false,
      isTicketBlockCrud: false,
      isTicketBlockView: false,
      isAddressBookCrud: false,
      isAddressBookView: true,
      isUserCrud: false,
      isUserView: false,
      isListView: false,
      isListCrud: false,
      isUpload: false,
      isEmail: false,
      isReports: false,
      isMassRemove: false,
      isCustomLayout: false,
      isPayments: false,
      isWillCall: false,
      isPartner: false,
      isInventoryRecords: false,
      isContestScores: false,
      isPoolContact: false,
      isExhibitorTeamMember: false
    }, {
      slug: 'user-crud',
      name: 'User CRUD',
      description: null,
      isNone: false,
      isUser: false,
      isAdmin: false,
      isEventCrud: false,
      isEventView: false,
      isTicketBlockCrud: false,
      isTicketBlockView: false,
      isAddressBookCrud: false,
      isAddressBookView: false,
      isUserCrud: true,
      isUserView: false,
      isListView: false,
      isListCrud: false,
      isUpload: false,
      isEmail: false,
      isReports: false,
      isMassRemove: false,
      isCustomLayout: false,
      isPayments: false,
      isWillCall: false,
      isPartner: false,
      isInventoryRecords: false,
      isContestScores: false,
      isPoolContact: false,
      isExhibitorTeamMember: false
    }, {
      slug: 'user-view',
      name: 'User View',
      description: null,
      isNone: false,
      isUser: false,
      isAdmin: false,
      isEventCrud: false,
      isEventView: false,
      isTicketBlockCrud: false,
      isTicketBlockView: false,
      isAddressBookCrud: false,
      isAddressBookView: false,
      isUserCrud: false,
      isUserView: true,
      isListView: false,
      isListCrud: false,
      isUpload: false,
      isEmail: false,
      isReports: false,
      isMassRemove: false,
      isCustomLayout: false,
      isPayments: false,
      isWillCall: false,
      isPartner: false,
      isInventoryRecords: false,
      isContestScores: false,
      isPoolContact: false,
      isExhibitorTeamMember: false
    }, {
      slug: 'list-view',
      name: 'List View',
      description: null,
      isNone: false,
      isUser: false,
      isAdmin: false,
      isEventCrud: false,
      isEventView: false,
      isTicketBlockCrud: false,
      isTicketBlockView: false,
      isAddressBookCrud: false,
      isAddressBookView: false,
      isUserCrud: false,
      isUserView: false,
      isListView: true,
      isListCrud: false,
      isUpload: false,
      isEmail: false,
      isReports: false,
      isMassRemove: false,
      isCustomLayout: false,
      isPayments: false,
      isWillCall: false,
      isPartner: false,
      isInventoryRecords: false,
      isContestScores: false,
      isPoolContact: false,
      isExhibitorTeamMember: false
    }, {
      slug: 'list-crud',
      name: 'List CRUD',
      description: null,
      isNone: false,
      isUser: false,
      isAdmin: false,
      isEventCrud: false,
      isEventView: false,
      isTicketBlockCrud: false,
      isTicketBlockView: false,
      isAddressBookCrud: false,
      isAddressBookView: false,
      isUserCrud: false,
      isUserView: false,
      isListView: false,
      isListCrud: true,
      isUpload: false,
      isEmail: false,
      isReports: false,
      isMassRemove: false,
      isCustomLayout: false,
      isPayments: false,
      isWillCall: false,
      isPartner: false,
      isInventoryRecords: false,
      isContestScores: false,
      isPoolContact: false,
      isExhibitorTeamMember: false
    }, {
      slug: 'upload',
      name: 'Upload',
      description: null,
      isNone: false,
      isUser: false,
      isAdmin: false,
      isEventCrud: false,
      isEventView: false,
      isTicketBlockCrud: false,
      isTicketBlockView: false,
      isAddressBookCrud: false,
      isAddressBookView: false,
      isUserCrud: false,
      isUserView: false,
      isListView: false,
      isListCrud: false,
      isUpload: true,
      isEmail: false,
      isReports: false,
      isMassRemove: false,
      isCustomLayout: false,
      isPayments: false,
      isWillCall: false,
      isPartner: false,
      isInventoryRecords: false,
      isContestScores: false,
      isPoolContact: false,
      isExhibitorTeamMember: false
    }, {
      slug: 'email',
      name: 'Email',
      description: null,
      isNone: false,
      isUser: false,
      isAdmin: false,
      isEventCrud: false,
      isEventView: false,
      isTicketBlockCrud: false,
      isTicketBlockView: false,
      isAddressBookCrud: false,
      isAddressBookView: false,
      isUserCrud: false,
      isUserView: false,
      isListView: false,
      isListCrud: false,
      isUpload: false,
      isEmail: true,
      isReports: false,
      isMassRemove: false,
      isCustomLayout: false,
      isPayments: false,
      isWillCall: false,
      isPartner: false,
      isInventoryRecords: false,
      isContestScores: false,
      isPoolContact: false,
      isExhibitorTeamMember: false
    }, {
      slug: 'reports',
      name: 'Reports',
      description: null,
      isNone: false,
      isUser: false,
      isAdmin: false,
      isEventCrud: false,
      isEventView: false,
      isTicketBlockCrud: false,
      isTicketBlockView: false,
      isAddressBookCrud: false,
      isAddressBookView: false,
      isUserCrud: false,
      isUserView: false,
      isListView: false,
      isListCrud: false,
      isUpload: false,
      isEmail: false,
      isReports: true,
      isMassRemove: false,
      isCustomLayout: false,
      isPayments: false,
      isWillCall: false,
      isPartner: false,
      isInventoryRecords: false,
      isContestScores: false,
      isPoolContact: false,
      isExhibitorTeamMember: false
    }, {
      slug: 'mass-remove',
      name: 'Mass Remove',
      description: null,
      isNone: false,
      isUser: false,
      isAdmin: false,
      isEventCrud: false,
      isEventView: false,
      isTicketBlockCrud: false,
      isTicketBlockView: false,
      isAddressBookCrud: false,
      isAddressBookView: false,
      isUserCrud: false,
      isUserView: false,
      isListView: false,
      isListCrud: false,
      isUpload: false,
      isEmail: false,
      isReports: false,
      isMassRemove: true,
      isCustomLayout: false,
      isPayments: false,
      isWillCall: false,
      isPartner: false,
      isInventoryRecords: false,
      isContestScores: false,
      isPoolContact: false,
      isExhibitorTeamMember: false
    }, {
      slug: 'custom-layout',
      name: 'Custom Layout',
      description: null,
      isNone: false,
      isUser: false,
      isAdmin: false,
      isEventCrud: false,
      isEventView: false,
      isTicketBlockCrud: false,
      isTicketBlockView: false,
      isAddressBookCrud: false,
      isAddressBookView: false,
      isUserCrud: false,
      isUserView: false,
      isListView: false,
      isListCrud: false,
      isUpload: false,
      isEmail: false,
      isReports: false,
      isMassRemove: false,
      isCustomLayout: true,
      isPayments: false,
      isWillCall: false,
      isPartner: false,
      isInventoryRecords: false,
      isContestScores: false,
      isPoolContact: false,
      isExhibitorTeamMember: false
    }, {
      slug: 'payments',
      name: 'Payments',
      description: null,
      isNone: false,
      isUser: false,
      isAdmin: false,
      isEventCrud: false,
      isEventView: false,
      isTicketBlockCrud: false,
      isTicketBlockView: false,
      isAddressBookCrud: false,
      isAddressBookView: false,
      isUserCrud: false,
      isUserView: false,
      isListView: false,
      isListCrud: false,
      isUpload: false,
      isEmail: false,
      isReports: false,
      isMassRemove: false,
      isCustomLayout: false,
      isPayments: true,
      isWillCall: false,
      isPartner: false,
      isInventoryRecords: false,
      isContestScores: false,
      isPoolContact: false,
      isExhibitorTeamMember: false
    }, {
      slug: 'will-call',
      name: 'Will Call',
      description: null,
      isNone: false,
      isUser: false,
      isAdmin: false,
      isEventCrud: false,
      isEventView: false,
      isTicketBlockCrud: false,
      isTicketBlockView: false,
      isAddressBookCrud: false,
      isAddressBookView: false,
      isUserCrud: false,
      isUserView: false,
      isListView: false,
      isListCrud: false,
      isUpload: false,
      isEmail: false,
      isReports: false,
      isMassRemove: false,
      isCustomLayout: false,
      isPayments: false,
      isWillCall: true,
      isPartner: false,
      isInventoryRecords: false,
      isContestScores: false,
      isPoolContact: false,
      isExhibitorTeamMember: false
    }, {
      slug: 'partner',
      name: 'Partner',
      description: null,
      isNone: false,
      isUser: false,
      isAdmin: false,
      isEventCrud: false,
      isEventView: false,
      isTicketBlockCrud: false,
      isTicketBlockView: false,
      isAddressBookCrud: false,
      isAddressBookView: false,
      isUserCrud: false,
      isUserView: false,
      isListView: false,
      isListCrud: false,
      isUpload: false,
      isEmail: false,
      isReports: false,
      isMassRemove: false,
      isCustomLayout: false,
      isPayments: false,
      isWillCall: false,
      isPartner: true,
      isInventoryRecords: false,
      isContestScores: false,
      isPoolContact: false,
      isExhibitorTeamMember: false
    }, {
      slug: 'inventory-records',
      name: 'Inventory Records',
      description: null,
      isNone: false,
      isUser: false,
      isAdmin: false,
      isEventCrud: false,
      isEventView: false,
      isTicketBlockCrud: false,
      isTicketBlockView: false,
      isAddressBookCrud: false,
      isAddressBookView: false,
      isUserCrud: false,
      isUserView: false,
      isListView: false,
      isListCrud: false,
      isUpload: false,
      isEmail: false,
      isReports: false,
      isMassRemove: false,
      isCustomLayout: false,
      isPayments: false,
      isWillCall: false,
      isPartner: false,
      isInventoryRecords: true,
      isContestScores: false,
      isPoolContact: false,
      isExhibitorTeamMember: false
    }, {
      slug: 'contest-scores',
      name: 'Contest Scores',
      description: null,
      isNone: false,
      isUser: false,
      isAdmin: false,
      isEventCrud: false,
      isEventView: false,
      isTicketBlockCrud: false,
      isTicketBlockView: false,
      isAddressBookCrud: false,
      isAddressBookView: false,
      isUserCrud: false,
      isUserView: false,
      isListView: false,
      isListCrud: false,
      isUpload: false,
      isEmail: false,
      isReports: false,
      isMassRemove: false,
      isCustomLayout: false,
      isPayments: false,
      isWillCall: false,
      isPartner: false,
      isInventoryRecords: false,
      isContestScores: true,
      isPoolContact: false,
      isExhibitorTeamMember: false
    }, {
      slug: 'pool-contact',
      name: 'Pool Contact',
      description: null,
      isNone: false,
      isUser: false,
      isAdmin: false,
      isEventCrud: false,
      isEventView: false,
      isTicketBlockCrud: false,
      isTicketBlockView: false,
      isAddressBookCrud: false,
      isAddressBookView: false,
      isUserCrud: false,
      isUserView: false,
      isListView: false,
      isListCrud: false,
      isUpload: false,
      isEmail: false,
      isReports: false,
      isMassRemove: false,
      isCustomLayout: false,
      isPayments: false,
      isWillCall: false,
      isPartner: false,
      isInventoryRecords: false,
      isContestScores: false,
      isPoolContact: true,
      isExhibitorTeamMember: false
    }, {
      slug: 'exhibitor-team-member',
      name: 'Exhibitor Team Member',
      description: null,
      isNone: false,
      isUser: false,
      isAdmin: false,
      isEventCrud: false,
      isEventView: false,
      isTicketBlockCrud: false,
      isTicketBlockView: false,
      isAddressBookCrud: false,
      isAddressBookView: false,
      isUserCrud: false,
      isUserView: false,
      isListView: false,
      isListCrud: false,
      isUpload: false,
      isEmail: false,
      isReports: false,
      isMassRemove: false,
      isCustomLayout: false,
      isPayments: false,
      isWillCall: false,
      isPartner: false,
      isInventoryRecords: false,
      isContestScores: false,
      isPoolContact: false,
      isExhibitorTeamMember: true
    }];
  };

  User.prototype.TokenStateType = function () {
    return [{
      slug: 'success',
      name: 'Success',
      description: null,
      isSuccess: true,
      isFailure: false,
      isUnknown: false
    }, {
      slug: 'failure',
      name: 'Failure',
      description: null,
      isSuccess: false,
      isFailure: true,
      isUnknown: false
    }, {
      slug: 'unknown',
      name: 'Unknown',
      description: null,
      isSuccess: false,
      isFailure: false,
      isUnknown: true
    }];
  };

  User.prototype.UserAttributeNamespaceType = function () {
    return [{
      slug: 'internal',
      name: 'Internal',
      description: null,
      isInternal: true,
      isInfo: false,
      isHover: false,
      isSpamReport: false,
      isLinkedin: false,
      isSalesforce: false,
      isTwitter: false,
      isConvio: false,
      isGoogle: false,
      isCustom: false,
      isVirbela: false,
      isHealthpass: false
    }, {
      slug: 'info',
      name: 'Info',
      description: null,
      isInternal: false,
      isInfo: true,
      isHover: false,
      isSpamReport: false,
      isLinkedin: false,
      isSalesforce: false,
      isTwitter: false,
      isConvio: false,
      isGoogle: false,
      isCustom: false,
      isVirbela: false,
      isHealthpass: false
    }, {
      slug: 'hover',
      name: 'Hover',
      description: null,
      isInternal: false,
      isInfo: false,
      isHover: true,
      isSpamReport: false,
      isLinkedin: false,
      isSalesforce: false,
      isTwitter: false,
      isConvio: false,
      isGoogle: false,
      isCustom: false,
      isVirbela: false,
      isHealthpass: false
    }, {
      slug: 'facebook',
      name: 'Facebook',
      description: null,
      isInternal: false,
      isInfo: false,
      isHover: false,
      isSpamReport: true,
      isLinkedin: false,
      isSalesforce: false,
      isTwitter: false,
      isConvio: false,
      isGoogle: false,
      isCustom: false,
      isVirbela: false,
      isHealthpass: false
    }, {
      slug: 'linked-in',
      name: 'Linked In',
      description: null,
      isInternal: false,
      isInfo: false,
      isHover: false,
      isSpamReport: false,
      isLinkedin: true,
      isSalesforce: false,
      isTwitter: false,
      isConvio: false,
      isGoogle: false,
      isCustom: false,
      isVirbela: false,
      isHealthpass: false
    }, {
      slug: 'salesforce',
      name: 'Salesforce',
      description: null,
      isInternal: false,
      isInfo: false,
      isHover: false,
      isSpamReport: false,
      isLinkedin: false,
      isSalesforce: true,
      isTwitter: false,
      isConvio: false,
      isGoogle: false,
      isCustom: false,
      isVirbela: false,
      isHealthpass: false
    }, {
      slug: 'twitter',
      name: 'Twitter',
      description: null,
      isInternal: false,
      isInfo: false,
      isHover: false,
      isSpamReport: false,
      isLinkedin: false,
      isSalesforce: false,
      isTwitter: true,
      isConvio: false,
      isGoogle: false,
      isCustom: false,
      isVirbela: false,
      isHealthpass: false
    }, {
      slug: 'convio',
      name: 'Convio',
      description: null,
      isInternal: false,
      isInfo: false,
      isHover: false,
      isSpamReport: false,
      isLinkedin: false,
      isSalesforce: false,
      isTwitter: false,
      isConvio: true,
      isGoogle: false,
      isCustom: false,
      isVirbela: false,
      isHealthpass: false
    }, {
      slug: 'google',
      name: 'Google',
      description: null,
      isInternal: false,
      isInfo: false,
      isHover: false,
      isSpamReport: false,
      isLinkedin: false,
      isSalesforce: false,
      isTwitter: false,
      isConvio: false,
      isGoogle: true,
      isCustom: false,
      isVirbela: false,
      isHealthpass: false
    }, {
      slug: 'custom',
      name: 'Custom',
      description: null,
      isInternal: false,
      isInfo: false,
      isHover: false,
      isSpamReport: false,
      isLinkedin: false,
      isSalesforce: false,
      isTwitter: false,
      isConvio: false,
      isGoogle: false,
      isCustom: true,
      isVirbela: false,
      isHealthpass: false
    }, {
      slug: 'virbela',
      name: 'Virbela',
      description: null,
      isInternal: false,
      isInfo: false,
      isHover: false,
      isSpamReport: false,
      isLinkedin: false,
      isSalesforce: false,
      isTwitter: false,
      isConvio: false,
      isGoogle: false,
      isCustom: false,
      isVirbela: true,
      isHealthpass: false
    }, {
      slug: 'healthpass',
      name: 'Healthpass',
      description: null,
      isInternal: false,
      isInfo: false,
      isHover: false,
      isSpamReport: false,
      isLinkedin: false,
      isSalesforce: false,
      isTwitter: false,
      isConvio: false,
      isGoogle: false,
      isCustom: false,
      isVirbela: false,
      isHealthpass: true
    }];
  };

  User.prototype.UserIdentifierType = function () {
    return [{
      slug: 'email',
      name: 'Email',
      description: null,
      isEmail: true,
      isIpad: false,
      isSfLead: false,
      isSfContact: false
    }, {
      slug: 'ipad',
      name: 'iPad',
      description: null,
      isEmail: false,
      isIpad: true,
      isSfLead: false,
      isSfContact: false
    }, {
      slug: 'salesforce-lead',
      name: 'Salesforce Lead',
      description: null,
      isEmail: false,
      isIpad: false,
      isSfLead: true,
      isSfContact: false
    }, {
      slug: 'salesforce-contact',
      name: 'Salesforce Contact',
      description: null,
      isEmail: false,
      isIpad: false,
      isSfLead: false,
      isSfContact: true
    }];
  };

  User.prototype.UserPermissionType = function () {
    return [{
      slug: 'group',
      name: 'Group',
      description: null,
      isGroup: true
    }];
  };

  User.prototype.UserRoleType = function () {
    return [{
      slug: 'global',
      name: 'Global',
      description: null,
      isGlobal: true,
      isEvents: false,
      isTicketblocks: false,
      isPools: false,
      isExhibitors: false
    }, {
      slug: 'events',
      name: 'Events',
      description: null,
      isGlobal: false,
      isEvents: true,
      isTicketblocks: false,
      isPools: false,
      isExhibitors: false
    }, {
      slug: 'ticketblocks',
      name: 'TicketBlocks',
      description: null,
      isGlobal: false,
      isEvents: false,
      isTicketblocks: true,
      isPools: false,
      isExhibitors: false
    }, {
      slug: 'pools',
      name: 'Pools',
      description: null,
      isGlobal: false,
      isEvents: false,
      isTicketblocks: false,
      isPools: true,
      isExhibitors: false
    }, {
      slug: 'exhibitors',
      name: 'Exhibitors',
      description: null,
      isGlobal: false,
      isEvents: false,
      isTicketblocks: false,
      isPools: false,
      isExhibitors: true
    }];
  };

  User.prototype.UserUnsubscribePreferenceType = function () {
    return [{
      slug: 'global',
      name: 'Global',
      description: null,
      isGlobal: true,
      isPool: false,
      isEvent: false,
      isTicketblock: false
    }, {
      slug: 'pool',
      name: 'Pool',
      description: null,
      isGlobal: false,
      isPool: true,
      isEvent: false,
      isTicketblock: false
    }, {
      slug: 'event',
      name: 'Event',
      description: null,
      isGlobal: false,
      isPool: false,
      isEvent: true,
      isTicketblock: false
    }, {
      slug: 'ticketblock',
      name: 'Ticketblock',
      description: null,
      isGlobal: false,
      isPool: false,
      isEvent: false,
      isTicketblock: true
    }];
  };

  return User;
}();

exports.User = User;